<script setup>
import { markRaw } from 'vue'
import ComexDrilldownLayout from '@/components/base/fluxo/ComexDrilldownLayout.vue'
import ContratoVendaForm from '@/components/Vendas/contratosVenda/ContratoVendaForm.vue'
import PedidoVendaCadastro from '@/components/Vendas/pedidoVenda/PedidoVendaCadastro.vue'
import { useActiveScreen } from '@/composables/useActiveScreen'

defineProps({
  itemParaEditar: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['item-atualizado', 'cancelar', 'show-notification', 'changesDetected'])

// Registra o formulário real para o resolvedor de tela ativa
// O ContratoVendaCadastro sempre exibe ContratoVendaForm como primeiro estágio.
// Quando navega para PedidoVendaCadastro via drilldown, o próprio PedidoVendaCadastro
// já registra seu próprio activeForm via seu próprio orquestrador.
const { setActiveForm } = useActiveScreen()
setActiveForm('ContratoVendaForm')

const componentMap = {
  contrato: {
    component: markRaw(ContratoVendaForm),
    color: '#0f5c3a',
    icon: 'bi-file-earmark-text',
    title: 'Contrato'
  },
  pedido: {
    component: markRaw(PedidoVendaCadastro),
    color: 'var(--bs-success)',
    icon: 'bi-cart-check',
    title: 'Pedido de Venda'
  }
}

const pipelineStages = [
  { key: 'contrato', label: 'Contrato', icon: 'bi-file-earmark-text', color: '#0f5c3a' },
  { key: 'pedido', label: 'Pedido de Venda', icon: 'bi-cart-check', color: 'var(--bs-success)' }
]
</script>

<template>
  <ComexDrilldownLayout
    root-type="contrato"
    :root-item="itemParaEditar"
    :component-map="componentMap"
    :stages="pipelineStages"
    @item-atualizado="(item) => emit('item-atualizado', item)"
    @cancelar="emit('cancelar')"
    @show-notification="(notif) => emit('show-notification', notif)"
    @changes-detected="(v) => emit('changesDetected', v)"
  />
</template>
